<template>
  <ModalComponent
    :model-value="showRef"
    :close="() => handleCloseModal(true)"
    :max-width="maxWidth"
    :style-class-contain="styleClassContain"
    :modal-class="showRef ? 'date-picker-modal' : ''"
    :height-modal="`${
      vendorValueRef === addANewVendor ? '100vh - 150px' : '100vh'
    }`"
    :class-name="`modal-create-assessment`"
  >
    <ModalHeader
      style="z-index: 10"
      :title="
        isPage === pageModal.page3
          ? getComponentUiText(
              'app-menu-submenu-assess-vendor-assessments-send-assessment-button-title-1',
            )
          : getComponentUiText(
              'app-component-assessment-create-assessment-modal-title-create-new-assessment-1',
            )
      "
      :sub-title="subTitle"
      @close="handleCloseModal"
    />
    <CreateVendorAssessmentModal
      v-if="!assessmentTemplateValueRef"
      :show="true"
      :is-show-warning="isShowWarning"
      @update:template-id="updateTemplateId"
      @update:close="handleCloseModal"
      @update:selection="
        (value) => {
          templateSelection = value;
          handlePrePopulateRecipientDetails();
        }
      "
    />
    <!-- Page 1 -->
    <div v-else>
      <div
        v-if="isPage === pageModal.page1"
        class="tw-pt-0 tw-flex tw-flex-col"
      >
        <div
          class="tw-text-[15px] tw-px-[40px] tw-py-[25px] tw-flex tw-gap-[20px] tw-items-center tw-justify-between tw-text-[#211F58] tw-bg-[#F2F8FF] tw-flex-wrap"
        >
          <BaseInput
            id="name"
            v-model="assessmentTemplateValueRef"
            :container="'tw-w-full '"
            :class-name="'!tw-items-center !tw-mt-[0px] '"
            :class-name-label="'tw-text-[16px] tw-leading-[130%] tw-font-semibold'"
            :label="
              getComponentUiText(
                'app-vendor-create-assessments-new-a-assessment-title-assessment-template-1',
              )
            "
          >
            <div class="input-container email-container tw-flex">
              <div class="input-container tw-grow tw-flex-1">
                <BaseDropDown
                  :id="'assessment-template'"
                  v-model="assessmentTemplateValueRef"
                  :data="assessmentTemplateData"
                  data-cy-id="assessment-template-dropdown-btn"
                  :class-name="'gray-dropdown-container tw-h-[58px] tw-rounded-md !tw-bg-[#fff]'"
                  :placeholder="
                    getComponentUiText(
                      'app-vendor-dropdown-placehoder-choose-template-1',
                    )
                  "
                  :bg-dropdown="'#FFF'"
                  :class-text-name="'tw-font-medium tw-text-[#231F20]'"
                  :custom-select-container="'tw-text-[13px] tw-font-normal tw-leading-[15px]'"
                />
              </div>
            </div>
          </BaseInput>
        </div>

        <!-- Select vendor -->
        <div
          v-if="title"
          class="tw-text-[25px] tw-flex tw-flex-col tw-gap-[10px]"
        >
          <div
            class="tw-font-semibold tw-text-[#211F58] tw-leading-[normal] tw-mb-[15px] tw-bg-[#F2F8FF]"
          >
            {{ title }}
          </div>
        </div>
        <div
          class="tw-p-[40px] tw-text-[15px] tw-flex tw-flex-col tw-gap-[25px] tw-items-start tw-justify-between tw-py-[40px] tw-text-[#211F58] tw-border-0 tw-border-t-[1px] tw-border-solid tw-border-[#EFF0F1]"
        >
          <div class="tw-text-[16px] tw-leading-[130%] tw-font-semibold">
            {{
              getComponentUiText(
                "app-vendor-create-assessments-new-a-assessment-title-select-vendor-1",
              )
            }}
            <div
              class="tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-normal tw-mt-[10px]"
            >
              {{
                getComponentUiText(
                  "app-vendor-create-assessments-new-a-assessment-description-select-vendor-1",
                )
              }}
            </div>
          </div>
          <div
            class="tw-flex tw-items-center tw-justify-between tw-w-full tw-flex-wrap tw-gap-2"
          >
            <BaseInput
              id="name"
              v-model="vendorValueRef"
              :validation="$v.vendorSelect"
              :container="'tw-w-full '"
              :class-name="'!tw-items-center !tw-mt-[0px]'"
              :label="
                getComponentUiText(
                  'app-vendor-create-assessments-new-a-assessment-title-select-vendor-1',
                )
              "
            >
              <div class="input-container email-container tw-flex">
                <div class="input-container tw-grow tw-flex-1">
                  <BaseDropDown
                    :id="'vendor-select'"
                    v-model="vendorValueRef"
                    :validation="$v.vendorSelect"
                    data-cy-id="select-vendor-dropdown-btn"
                    :data="selectVendorData as IDropDownData[]"
                    :class-name="'gray-dropdown-container tw-h-[58px] tw-font-medium'"
                    :placeholder="
                      getComponentUiText('app-prospect-questions-select-text-1')
                    "
                    :custom-select-container="'tw-text-[13px] tw-font-normal tw-leading-[15px]'"
                    :is-option-button-dropdown="true"
                    :text-option-button-dropdown="
                      getComponentUiText(
                        'app-vendor-create-assessment-new-a-assessment-option-dropdown-1',
                      )
                    "
                    :disabled="subTitle !== ''"
                    @update:model-value="
                      (value) => {
                        vendorValueRef = value;
                        handlePrePopulateRecipientDetails(value);
                      }
                    "
                  >
                    <template #feedback><div></div></template>
                  </BaseDropDown>
                </div>
              </div>
            </BaseInput>
          </div>
        </div>

        <!-- Vendor details -->
        <VendorDetails
          v-if="vendorValueRef === addANewVendor"
          ref="vendorDetailsRef"
          v-model="vendorDetailsModal"
          @update:is-disabled="(val) => (isRequiredVendorDetail = val)"
        />

        <!-- Recipient details -->
        <RecipientsDetails
          v-if="vendorValueRef === addANewVendor || vendorValueRef !== null"
          ref="recipientsDetailsRef"
          v-model="recipientsDetailsModal"
          :show-warning="showRecipientDetailsWarning"
          @update:is-disabled="(val) => (isRequiredRecipientDetails = val)"
        />
      </div>

      <!-- Page 2 -->
      <AssessmentDetailsVendorAssessmentModal
        v-if="isPage === pageModal.page2"
        v-model="assessmentDetailsModal"
      />

      <!-- Page 3 -->
      <CreateNewVendorAssessmentCompleteSection
        v-if="isPage === pageModal.page3"
        :secret="secret"
      />

      <!-- Action button -->
      <div
        :class="`tw-px-[40px] tw-pb-[40px] tw-flex sm:tw-flex-row tw-flex-col tw-justify-between tw-gap-[15px] sm:tw-gap-[0px]`"
      >
        <button
          data-cy="create-new-vendor-assessment-modal-cancel-btn"
          class="tw-bg-[#fff] hover:!tw-bg-[#F7553C] hover:tw-text-[#fff] tw-text-[#F7553C] tw-border-[2px] tw-border-solid tw-border-[#F7553C] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-rounded-[27px] tw-w-fit tw-h-[39px] tw-leading-[100%] tw-font-medium tw-flex tw-items-center tw-justify-center"
          @click="() => handleCloseModal()"
        >
          {{
            getComponentUiText(
              "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
            )
          }}
        </button>

        <div class="tw-flex tw-gap-[10px] tw-items-center">
          <button
            v-if="isPage !== pageModal.page1"
            data-cy="create-new-vendor-assessment-modal-previous-btn"
            class="tw-flex tw-items-center tw-bg-[#FFF] tw-text-[#387DFF] tw-border-2 tw-border-solid tw-border-[#387DFF] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-rounded-[27px] tw-h-[39px] tw-leading-[100%] tw-font-medium"
            @click="handlePrevious"
          >
            {{
              getComponentUiText(
                "app-modal-create-a-new-vendor-assessment-btn-previous-1",
              )
            }}
          </button>

          <button
            data-cy="create-new-vendor-assessment-modal-next-btn"
            class="tw-flex tw-items-center tw-justify-center tw-bg-[#DBDBDB] tw-text-[#B7B7B7] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-rounded-[27px] tw-h-[39px] tw-leading-[100%] tw-font-medium tw-min-w-[75px]"
            :class="`${'!tw-bg-[#387DFF] tw-text-white hover:!tw-bg-[#0069d9]'}`"
            @click="handleNext"
          >
            <span v-if="!isLoadingAPI" ref="innerTextNextBtnRef">
              {{
                getComponentUiText(
                  isPage === pageModal.page3 ||
                    (isPage === pageModal.page2 &&
                      !currentOrgSecretRequired.secretRequiredChecklistRequested)
                    ? "app-component-assessments-checklists-assessment-details-card-label-3"
                    : "app-vendor-create-assessments-new-a-assessment-btn-next-1",
                )
              }}
            </span>
            <div
              v-else
              :style="{ width: animationWidth + 'px' }"
              class="tw-flex tw-justify-center tw-h-[39px] tw-w-[39px] tw-text-[#FFF] tw-cursor-not-allowed"
            >
              <!-- eslint-disable vue/no-unused-refs -->
              <LottieAnimation
                ref="anim"
                :animation-data="ProgressAnimation"
                :auto-play="true"
                :loop="true"
              />
            </div>
          </button>
        </div>
      </div>
    </div>
  </ModalComponent>
</template>

<script setup lang="ts">
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import {
  computed,
  onBeforeMount,
  onMounted,
  onUnmounted,
  Ref,
  ref,
  watch,
} from "vue";
import ModalComponent from "@/components/common/modalComponent.vue";
import store from "@/store";
import BaseDropDown from "../common/form/baseDropDown.vue";
import BaseInput from "../common/form/baseInput.vue";
import RecipientsDetails from "./recipientDetails.vue";
import type RecipientsDetailsType from "./recipientDetails.vue";
import VendorDetails from "./vendorDetails.vue";
import AssessmentDetailsVendorAssessmentModal from "./assessmentDetailsVendorAssessmentModal.vue";
import CreateNewVendorAssessmentCompleteSection from "./createNewVendorAssessmentCompleteSection.vue";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";
import CreateVendorAssessmentModal from "./createVendorAssessmentModal.vue";
import { helpers, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {
  getRequestedDetailItem,
  getVendorProviders,
  postVendorProviders,
} from "@/services/vendor";
import { IVendorProvider } from "@/interfaces/vendor";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import { OPTION_EXPIRY_DATE_VENDOR } from "@/utils/constants";
import { Vendor } from "../../services/apiRoutes/routes";
import { showErrorAPI } from "@/services/apiRoutes";
import get from "lodash/get";

const pageModal = {
  page1: 1,
  page2: 2,
  page3: 3,
};

const addANewVendor = "addANewVendor";

const props = defineProps({
  title: {
    type: String,
    required: false,
    default: "",
  },
  show: {
    type: Boolean,
    required: true,
  },
  maxWidth: {
    type: Number,
    required: false,
    default: 65,
  },
  templateId: {
    type: Number,
    required: false,
    default: 0,
  },
  subTitle: {
    type: String,
    required: false,
    default: "",
  },
  providerId: {
    type: String,
    required: false,
    default: null,
  },
  isShowWarning: {
    type: Boolean,
    required: false,
    default: false,
  },
  provider: {
    type: Object,
    required: false,
    default: () => ({}),
  },
});

let showRef = ref(props.show);
const recipientsDetailsRef = ref<InstanceType<
  typeof RecipientsDetailsType
> | null>(null);
const assessmentTemplateValueRef = ref(props.templateId);
const vendorDetailsRef = ref<InstanceType<typeof RecipientsDetailsType> | null>(
  null,
);
const currentOrgSecretRequired = computed(
  () => store.state.Org.currentOrgSecretRequired,
);
const vendorValueRef = ref(props.providerId ?? null);
const templateSelection = ref();
const isPage = ref(pageModal.page1);
const isRequiredRecipientDetails = ref(false);
const isRequiredVendorDetail = ref(false);
const isSuccessCallAPI = ref(false);
const updateData = ref(false);
const isLoadingAPI = ref(false);
const showRecipientDetailsWarning = ref(false);
const vendorDetailsModal = ref({
  companyName: "",
  description: "",
});
const recipientsDetailsModal = ref({
  name: "",
  email: "",
  expiryDate: "",
  expiryDateOption: OPTION_EXPIRY_DATE_VENDOR.ONE_WEEK,
});

const assessmentDetailsModal = ref({
  internalDescription: "",
  internalNotes: "",
  assessmentDescription: "",
  assessmentNotes: "",
});

const selectVendorData: Ref<IVendorProvider[]> = ref([]);

let dataFormModal;

const screenWidth = ref(window.innerWidth);
let animationWidth = ref(0);
const innerTextNextBtnRef: Ref = ref(null);

const updateWidth = () => {
  screenWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", updateWidth);
  initial();
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWidth);
});

const initial = async () => {
  fetchVendorSelectData();
};

const fetchVendorSelectData = async () => {
  const providers = await getVendorProviders();
  selectVendorData.value = providers.concat([
    {
      id: addANewVendor,
      name: getComponentUiText(
        "app-vendor-create-assessment-new-a-assessment-option-dropdown-1",
      ),
      color: "#387DFF",
    },
  ]);
};

const updateTemplateId = (value) => {
  assessmentTemplateValueRef.value = value;
};

watch(
  [
    vendorDetailsModal,
    assessmentDetailsModal,
    assessmentTemplateValueRef,
    vendorValueRef,
  ],
  (value) => {
    const object = {
      assessmentTemplateValueRef: assessmentTemplateValueRef.value,
      vendorValueRef: vendorValueRef.value,
      ...vendorDetailsModal.value,
      ...assessmentDetailsModal.value,
    };
    if (dataFormModal) {
      updateData.value = Object.keys(object).some(
        (key) => object[key] !== dataFormModal[key],
      );
    }
  },
  { deep: true },
);

const assessmentTemplateData = computed(() =>
  store.state.Vendor.checklistRequestedTemplate
    .filter((item) => item.itemCount > 0)
    .map((item) => ({
      id: item.templateId,
      name: item.templateName,
    })),
);

const secret = computed(() => store.state.Vendor.secret);

const checklistRequestedId = computed(
  () => store.state.Vendor.checklistRequestedId,
);

const requestedChecklistProviderIds = computed(() => {
  const requestedChecklist = store.state.Vendor.requestedChecklist;
  return requestedChecklist.map((i) => i.providerId);
});

const checklistRequestedEmailGrants = computed(
  () =>
    store.state.Vendor.checklistVendorRequestedExternalInput
      .checklistRequestedEmailGrants,
);

const rules = {
  vendorSelect: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
};
const formModel = ref({
  vendorSelect: vendorValueRef.value,
});
const $v = useVuelidate(rules, formModel as any);

watch(
  () => vendorValueRef.value,
  (value) => {
    if (value) {
      formModel.value.vendorSelect = value;
    }
  },
);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

const emit = defineEmits(["update:show", "update:data", "update:close"]);

const handleCloseModal = (fromModal = false) => {
  if (fromModal && templateSelection.value) return;
  showRef.value = false;
  emit("update:show", showRef.value);
};

const putChecklistRequested = async () => {
  isLoadingAPI.value = true;

  const name = assessmentTemplateData.value.find(
    (item) => item.id === assessmentTemplateValueRef.value,
  )?.name;

  const params = {
    checklistRequestedName: name,
    providerId: vendorValueRef.value,
    checklistRequestedDescInternal:
      assessmentDetailsModal.value.internalDescription,
    checklistRequestedDescExternal:
      assessmentDetailsModal.value.assessmentDescription,
    checklistRequestedNotesInternal: assessmentDetailsModal.value.internalNotes,
    checklistRequestedNotesExternal:
      assessmentDetailsModal.value.assessmentNotes,
  };
  try {
    await store.dispatch("Vendor/updateChecklistRequested", {
      params,
      checklistRequestedId: checklistRequestedId.value,
    });
    dataFormModal = {
      assessmentTemplateValueRef: assessmentTemplateValueRef.value,
      vendorValueRef: vendorValueRef.value,
      ...vendorDetailsModal.value,
      ...assessmentDetailsModal.value,
    };
    updateData.value = false;
  } catch (error) {
    isLoadingAPI.value = false;
    throw Error;
  }
};

const postChecklistRequested = async () => {
  isLoadingAPI.value = true;

  const name = assessmentTemplateData.value.find(
    (item) => item.id === assessmentTemplateValueRef.value,
  )?.name;

  if (isSuccessCallAPI.value && updateData.value) {
    putChecklistRequested();
    return;
  }

  if (isSuccessCallAPI.value) return;

  const params = {
    checklistRequestedName: name,
    templateId: assessmentTemplateValueRef.value,
    providerId: vendorValueRef.value,
    checklistRequestedDescInternal:
      assessmentDetailsModal.value.internalDescription,
    checklistRequestedDescExternal:
      assessmentDetailsModal.value.assessmentDescription,
    checklistRequestedNotesInternal: assessmentDetailsModal.value.internalNotes,
    checklistRequestedNotesExternal:
      assessmentDetailsModal.value.assessmentNotes,
  };
  dataFormModal = {
    assessmentTemplateValueRef: assessmentTemplateValueRef.value,
    vendorValueRef: vendorValueRef.value,
    ...vendorDetailsModal.value,
    ...assessmentDetailsModal.value,
  };
  updateData.value = false;
  try {
    await store.dispatch("Vendor/postChecklistRequested", params);
    isSuccessCallAPI.value = true;
  } catch (error) {
    throw Error;
  } finally {
    isLoadingAPI.value = false;
  }
};

const postChecklistRequestedGetSecret = async () => {
  isLoadingAPI.value = true;

  try {
    const recipientName = recipientsDetailsModal.value.name.split(" ");
    const recipientFirstName = recipientName[0];
    const recipientLastName = recipientName.slice(1).join(" ");
    await store.dispatch("Vendor/postChecklistRequestedGetSecret", {
      payload: {
        checklistRequestedId: checklistRequestedId.value,
        recipientEmail: recipientsDetailsModal.value.email,
        recipientFirstName,
        recipientLastName,
        offererOrgName: recipientsDetailsModal.value.name,
        validUntil: recipientsDetailsModal.value.expiryDate,
      },
    });
  } catch (error) {
    throw Error;
  } finally {
    isLoadingAPI.value = false;
  }
};

const postVendorProvider = async () => {
  isLoadingAPI.value = true;

  try {
    const params = {
      name: vendorDetailsModal.value.companyName,
      description: vendorDetailsModal.value.description,
    } as IVendorProvider;

    const res = await postVendorProviders(params);
    if (res && res.id) {
      vendorValueRef.value = res.id as any;
      return true;
    } else {
      return false;
    }
  } catch (error) {
    throw Error;
  } finally {
    isLoadingAPI.value = false;
  }
};

const handleNext = async () => {
  switch (isPage.value) {
    case pageModal.page1: {
      if (innerTextNextBtnRef.value) {
        animationWidth.value =
          innerTextNextBtnRef.value.getBoundingClientRect()["width"] as number;
      }
      const validateVendorSelect = await $v.value.$validate();
      const validateVendorDetail = await vendorDetailsRef.value?.isCheckValid();
      const validate = await recipientsDetailsRef.value?.isCheckValid();

      if (
        validate &&
        validateVendorSelect &&
        (validateVendorDetail?.isValid ||
          vendorValueRef.value !== addANewVendor)
      ) {
        if (vendorValueRef.value === addANewVendor) {
          const res = await postVendorProvider();
          if (!res) return;
          fetchVendorSelectData();
        }
        isPage.value = isPage.value + 1;
      }
      return;
    }
    case pageModal.page2: {
      if (isLoadingAPI.value) return;
      if (innerTextNextBtnRef.value) {
        animationWidth.value =
          innerTextNextBtnRef.value.getBoundingClientRect()["width"] as number;
      }
      try {
        await postChecklistRequested();
        await postChecklistRequestedGetSecret();
        store.dispatch("Vendor/fetchRequestedChecklist", {
          isArchived: false,
        });
        if (
          currentOrgSecretRequired.value &&
          currentOrgSecretRequired.value.secretRequiredChecklistRequested
        ) {
          isPage.value = isPage.value + 1;
        } else {
          handleCloseModal();
          emit("update:data");
        }
      } catch (error) {
        console.error("Error in handleNext:", error);
        isPage.value = pageModal.page2;
      }
      break;
    }
    case pageModal.page3: {
      handleCloseModal();
      break;
    }
    default:
      break;
  }
};

const handlePrevious = () => {
  isPage.value = isPage.value - 1;
};

const isFirstMount = ref(false);

const handlePrePopulateRecipientDetails = async (value?) => {
  if (props.provider && !isFirstMount.value) {
    isFirstMount.value = true;
    vendorValueRef.value = props.provider?.providerId
      ? props.provider?.providerId
      : value;
  }
  // Clear data before populate.
  showRecipientDetailsWarning.value = false;
  recipientsDetailsModal.value.email = "";
  recipientsDetailsModal.value.name = "";

  if (
    !vendorValueRef.value ||
    !requestedChecklistProviderIds.value.includes(vendorValueRef.value)
  )
    return;

  // Only Provider has Checklist Requested.
  const checklistData = store.state.Vendor.requestedChecklist;
  const checklist = checklistData.find(
    (item) => item.providerId === vendorValueRef.value,
  );

  if (!checklist) return;

  try {
    const res = await getRequestedDetailItem(checklist.checklistRequestedId);
    const emailGrant = get(
      res,
      "data.data.checklistsRequested[0].checklistRequestedEmailGrants[0]",
      {},
    );

    emailGrant.recipientEmail &&
      (recipientsDetailsModal.value.email = emailGrant.recipientEmail || "");

    (emailGrant.firstName || emailGrant.lastName) &&
      (recipientsDetailsModal.value.name = `${emailGrant.firstName || ""} ${
        emailGrant.lastName || ""
      }`);

    const isPopulate =
      recipientsDetailsModal.value.email || recipientsDetailsModal.value.name;

    isPopulate.length && (showRecipientDetailsWarning.value = true);
  } catch (error) {
    showErrorAPI(error, Vendor.getRequestedDetailItem);
  }
};

const styleClassContain = computed(() => ({
  "border-radius": "6px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
  overflow:
    (screenWidth.value >= 768 || assessmentTemplateValueRef.value) &&
    !vendorValueRef.value
      ? "unset !important"
      : "auto",
}));
</script>

<style scoped>
textarea::placeholder {
  color: #878787;
  font-size: 13px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

input::placeholder {
  color: #878787;
  font-size: 13px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
